<template>
    <div>
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" :colon="false">
            <a-form-model-item
                    ref="title"
                    label="标题"
                    prop="title"
                    :help="formErr.title"
                    :validateStatus='!formErr.title||formErr.title==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.title"
                        @change="(e) => { formErr.title=''}"
                        @blur="(e) => {  form.title = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="content"
                    label="内容"
                    prop="content"
                    :help="formErr.content"
                    :validateStatus='!formErr.content||formErr.content==""?"":"error"'
            >
                <a-input v-model="form.content"  type="hidden" />
                <ckeditor4 ref="ckeditor" :value="contenta" v-on:input="ckeditorContent" @instanceReadyCk="instanceReadyCk"></ckeditor4>
            </a-form-model-item>
            <a-form-model-item
                    ref="apply"
                    label="应用到"
                    prop="apply"
                    :extra="formErr.apply"
                    :validateStatus='!formErr.apply||formErr.apply==""?"":"error"'
            >
                <a-select v-model="form.apply">
                    <a-select-option :value="item.value" v-for="item in apply">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="item in this.status"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item   >
                <a-row>
                    <a-col :span="12">
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                            确定
                        </a-button>
                        <a-button  @click="onClose">
                            返回
                        </a-button>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../utils/utils"
    import ckeditor4 from '../../Components/ckeditors'
    import API from "./api";
    export default {
        name: "EditForm",
        data() {
            return {
                id: this.$route.query.id,
                apply:[],
                status:[],
                contenta: "",
                drawerConfig ,
                form: {
                    title:"",
                    content:"",
                    status:1,
                    apply:"",
                },
                formErr: {
                    title:"",
                    content:"",
                    status:"",
                    apply:"",
                },
                rules: {
                    title: [{required: true, message: "请输入标题",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.title)}  , trigger: "blur"  },],
                    content:[{required: true, message: "请输入内容",trigger:['change', 'blur']  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.content)}  , trigger:["blur","change"]   },],
                    apply: [{required: true, message: "请选择应用到",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.apply)}  , trigger: "blur"  },],

                },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span: 12 },
                },
            };

        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/Suggestions"; //设置左侧导航2-2 active
        },
        components:{ckeditor4},
        mounted(){
            // if(this.id!=undefined){ this.editform( )}
            this.getFormData()
        },
        methods: {
            instanceReadyCk(type){
                if(type==true){
                    let _that=this
                    this.$nextTick().then(function () {
                        if(_that.id!=undefined){ _that.editform(_that.id)}
                    })
                }

            },
            ckeditorContent(val) {
                this.form.content = val
                this.$refs.ruleForm.validateField('content', (contentError) => {
                    if(!phoneError){
                        //当校验通过时，这里面写逻辑代码
                        this.formErr.content=""
                    }
                })
            },
            editform(){
                API.service.EDIT_DATA(this.id).then(res => {
                    let data=res.data.data.info
                    this.form = data
                    let _that=this
                    this.$nextTick().then(function () {
                        _that.contenta = data.content_text
                    })
                    // this.$nextTick(() => {
                    //     setTimeout(() => {
                    //         this.contenta = data.content_text
                    //     }, 300)
                    // })
                    this.form.id=this.id
                })
            },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.apply=res.data.data.apply
                    this.status=res.data.data.status

                })
            },
            onClose(){
                    this.$router.push({path: '/WebsiteDetection/Suggestions'})
            },
            onSubmit() {
                let _this = this;
                this.$refs.ckeditor.$emit("getText")
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.content_text=subData.content
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                setTimeout(() => {
                                    this.onClose()
                                }, 1500)
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
    .ant-input-number-input{width: 100%!important;}
    .ant-input-number{width: 100%!important;}
</style>
